<template>
  <el-dialog title="绩效详情" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="formData" ref="form" label-width="120px" size="small">
      <!-- 基本信息 -->
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="员工姓名：">
            <span>{{ formData.employeeName || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检测年月：">
            <span>{{ formData.inspectionYearMonth || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="检测台数：">
            <span>{{ formData.inspectionCount || 0 }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="提成总额：">
            <span style="color: #f56c6c; font-weight: bold;">{{ formatMoney(formData.totalCommission) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="确认状态：">
            <el-tag :type="formData.confirmationStatus === '1' || formData.confirmationStatus === 1 ? 'success' : 'warning'">
              {{ formData.confirmationStatus === '1' || formData.confirmationStatus === 1 ? '已确认' : '待确认' }}
            </el-tag>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="formData.confirmedBy">
          <el-form-item label="确认人：">
            <span>{{ formData.confirmedBy || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="formData.confirmedTime">
        <el-col :span="8">
          <el-form-item label="确认时间：">
            <span>{{ formData.confirmedTime || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 提成明细列表 -->
    <div style="margin-top: 20px;">
      <h4 style="margin-bottom: 10px;">提成明细</h4>
      <el-table :data="detailList" border style="width: 100%;" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" max-height="400">
        <el-table-column type="index" label="序号" width="60" align="left"></el-table-column>
        <el-table-column label="使用单位" align="left" prop="useUntName" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="识别码" align="left" prop="oidno" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备品种" align="left" prop="eqpVartName" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="层数/高度/长度" align="left" prop="floorCount" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column label="检测日期" align="left" prop="inspectionDate" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.inspectionDate ? (scope.row.inspectionDate.split(' ')[0] || scope.row.inspectionDate) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="提成单价" align="right" prop="commissionRate" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.commissionRate) }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="提成金额" align="right" prop="commissionRate" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #f56c6c; font-weight: bold;">
              {{ scope.row.commissionRate === undefined || scope.row.commissionRate === null || scope.row.commissionRate === '' ? '-' : formatMoney(scope.row.commissionRate) }}
            </span>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { queryPerformanceDetails } from '@/api/contract/contract';

export default {
  name: 'DetailDialog',
  data () {
    return {
      dialogVisible: false,
      formData: {},
      detailList: []
    };
  },
  methods: {
    /**
     * 格式化金额
     */
    formatMoney (value) {
      if (value === null || value === undefined || value === '') {
        return '0.00';
      }
      return Number(value).toFixed(2);
    },

    /**
     * 打开弹窗
     * @param {Object} params - 查询参数
     * @param {Object} rowData - 行数据（用于显示基本信息）
     */
    openDialog (params, rowData) {
      this.dialogVisible = true;
      this.formData = { ...rowData };
      this.detailList = [];

      // 调用查询详情API
      queryPerformanceDetails(params).then(res => {
        // 详情接口 additionalData 为明细数组
        const details = (res && Array.isArray(res.additionalData)) ? res.additionalData : []
        this.detailList = details

        if (!details.length) {
          this.$message.warning('未获取到详情数据')
        }
      }).catch(error => {
        console.error('获取绩效详情失败:', error);
        this.$message.error('获取绩效详情失败');
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
